export default __webpack_public_path__ + "static/media/Pain of the Damned.829197a6.jpg";